import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class UserIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path fillRule="evenodd" d="M.037 16c-.082-.906-.037-1.787.228-2.634.165-.53.586-.872 1.102-1.033.735-.232 1.488-.402 2.226-.623.437-.132.88-.275 1.29-.479.927-.462 1.08-1.13.648-2.083a32.198 32.198 0 0 1-1.28-3.242c-.332-1.008-.345-2.06-.073-3.105C4.571 1.29 5.688.273 7.234.061c1.119-.155 2.188-.04 3.139.651 1.417 1.031 1.682 2.514 1.517 4.119-.154 1.491-.691 2.875-1.384 4.193-.594 1.13-.37 1.847.809 2.313.768.303 1.585.482 2.38.719.326.097.665.168.974.305.6.266 1.045.69 1.118 1.393.079.737.14 1.475.213 2.246H.037z"/></svg>
        )
    }
}

export default withCssClassName(UserIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/user-icon.js